/* Indulge spotlight (sections/indulge-home.liquid): unveils the device when the band scrolls into view.
   Styles: assets/indulge-home.css. Once seen, the band stays revealed for the rest of the visit (sessionStorage). */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('indulge-spotlight')) return;

  var KEY = 'indulge-home-seen';
  var UNVEIL_MS = 2400; // just over the longest unveil animation (glow flash 2.2s)

  function remember() {
    try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
  }

  class IndulgeSpotlight extends HTMLElement {
    connectedCallback() {
      if (this._ready || this.getAttribute('data-state') !== 'veiled') return;
      this._ready = true;
      var self = this;

      if (!('IntersectionObserver' in window)) { this.setAttribute('data-state', 'revealed'); return; }

      this._io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) self.reveal();
      }, { threshold: 0.45 });
      this._io.observe(this.querySelector('.indulge-home__stage') || this);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._timer) clearTimeout(this._timer);
    }

    reveal() {
      if (this.getAttribute('data-state') !== 'veiled') return;
      if (this._io) this._io.disconnect();
      remember();
      this.setAttribute('data-state', 'revealing');
      var self = this;
      this._timer = setTimeout(function () { self.setAttribute('data-state', 'revealed'); }, UNVEIL_MS);
    }
  }

  customElements.define('indulge-spotlight', IndulgeSpotlight);
})();
